import { EnumUserCountry, SignupInformationApi } from '@blank/api'
import { Auth0User } from 'modules/auth/types/auth0'
import { auth0Client } from 'modules/common/http/auth0Client'
import { chunk } from 'modules/common/lib/helpers/chunk/chunk'
import { EnumSignupType } from '../types/signup'

const MAX_METADATA_SIZE = 500

export interface PostUserProps {
  email: string
  password: string
  firstname: string
  lastname?: string
  signUpInformation?: SignupInformationApi
  userAcceptsCommercialSolicitation?: boolean
  sponsorshipVoucherCode?: string
  signupType?: EnumSignupType
  country: EnumUserCountry
  captchaToken: string
  hasAcknowledgedPrivacyPolicy: boolean
  hasConsentedForMarketing: boolean
  hasConsentedForThirdPartyCommunication: boolean
}

export const postUser = async (user: PostUserProps) => {
  const captchaChunks = chunk({
    data: user.captchaToken,
    maxSize: MAX_METADATA_SIZE,
    prefix: 'captchaToken',
  })

  const consents = {
    userAcceptsCommercialSolicitation:
      user.userAcceptsCommercialSolicitation || false,
    hasAcknowledgedPrivacyPolicy: user.hasAcknowledgedPrivacyPolicy || false,
    hasConsentedForMarketing: user.hasConsentedForMarketing || false,
    hasConsentedForThirdPartyCommunication:
      user.hasConsentedForThirdPartyCommunication || false,
  }

  const { data } = await auth0Client.post<Auth0User>('/dbconnections/signup', {
    clientId: process.env.NEXT_PUBLIC_AUTH0_CLIENTID,
    connection: process.env.NEXT_PUBLIC_AUTH0_CONNECTION,
    email: user.email,
    password: user.password,
    user_metadata: {
      firstname: user.firstname,
      lastname: user.lastname,
      signUpInformation: JSON.stringify(user.signUpInformation),
      signupType: user.signupType,
      country: user.country,
      voucherCode: user.sponsorshipVoucherCode,
      ...captchaChunks,
      consents: JSON.stringify(consents),
    },
  })

  return data
}
